import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
export function GoogleButton({ clientId, onCredential }) {
    const ref = useRef(null);
    useEffect(() => {
        const init = () => {
            if (!window.google || !ref.current)
                return;
            window.google.accounts.id.initialize({
                client_id: clientId,
                callback: (resp) => onCredential(resp.credential),
            });
            window.google.accounts.id.renderButton(ref.current, {
                theme: "outline",
                size: "large",
                text: "signin_with",
            });
        };
        if (window.google)
            init();
        else {
            const interval = setInterval(() => {
                if (window.google) {
                    init();
                    clearInterval(interval);
                }
            }, 100);
            return () => clearInterval(interval);
        }
    }, [clientId, onCredential]);
    return _jsx("div", { ref: ref });
}
